/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M.2197 6.7501c.0001 0 0 0 0 0a.75.75 0 1 1 1.0605-1.0608c.0003.0002-.0001-.0002 0 0L12 16.409 22.7197 5.6893A.75.75 0 0 1 23.7803 6.75L12 18.5302.2197 6.7501Z"
    clipRule="evenodd"
  />,
  'ChevronDown'
);
